import type { Pool } from '../../shared/types';

type UnknownRecord = Record<string, unknown>;

function isRecord(value: unknown): value is UnknownRecord {
  return typeof value === 'object' && value !== null;
}

function isPoolLike(value: unknown): value is Pool {
  if (!isRecord(value)) return false;

  return typeof value.id === 'number'
    && typeof value.slug === 'string'
    && value.slug.length > 0
    && typeof value.name === 'string';
}

export function normalizePoolDetailResponse(value: unknown): { pool: Pool | null; userRole: string | null } {
  if (isRecord(value) && isPoolLike(value.pool)) {
    return {
      pool: value.pool,
      userRole: typeof value.userRole === 'string' ? value.userRole : null,
    };
  }

  if (isPoolLike(value)) {
    return {
      pool: value,
      userRole: null,
    };
  }

  return {
    pool: null,
    userRole: null,
  };
}

export function normalizePoolMutationResponse(value: unknown): { pool: Pool | null; message: string } {
  if (isRecord(value) && isPoolLike(value.pool)) {
    return {
      pool: value.pool,
      message: typeof value.message === 'string' ? value.message : '',
    };
  }

  if (isPoolLike(value)) {
    return {
      pool: value,
      message: '',
    };
  }

  return {
    pool: null,
    message: '',
  };
}
